import {CustomerAddressType} from 'desktop/types/customerAddressesType';
import {capitalize} from 'libs/utils/utils';

import {ADDRESSES} from '../../../deliveryStepRootSaga/constants';

/**
 * Makes form data with data of updated address and returns data
 */
export const makeFormData = (
    address: CustomerAddressType,
    {
        customerId,
        isAddressesSame,
        type,
    }: {
        type: string;
        isAddressesSame: boolean;
        customerId: string;
    },
): Record<string, string | boolean | Object> => {
    const formData: Record<string, string | boolean | Object> = {
        city: address.city,
        countryCode: address.country,
        customer: {
            id: customerId,
        },
        firstname: address.firstName,
        lastname: address.lastName,
        postcode: address.zipCode,
        region: address.regionCode ? address.regionCode : address.region,
        street: address.street,
        telephone: address.phone,
    };
    if (address.regionId) formData.regionId = address.regionId;
    if (type) {
        formData[`default${capitalize(type)}`] = true;
        formData[`default${capitalize(ADDRESSES[type].oppositeValue)}`] = isAddressesSame;
    } else {
        formData.defaultShipping = true;
        formData.defaultBilling = true;
    }
    return formData;
};
